import { createFileRoute, redirect } from '@tanstack/react-router'

// Unpublished — see guides.tsx.
export const Route = createFileRoute('/guides_/$slug')({
  beforeLoad: () => {
    throw redirect({ to: '/', statusCode: 301 })
  },
})
